module.exports = __webpack_public_path__ + "media/images/top-parts-06-9e730dac1c81f05900ddc22198a594df.jpg";